module.exports = __webpack_public_path__ + "assets/img/未标题-2副s本.115b8c1e.png";